import { type SessionType } from '@prisma/client'
import { createContext, useContext, useState, type ReactNode } from 'react'

export type SessionMode = SessionType | null

interface FocusModeContextType {
	mode: SessionMode
	setMode: (mode: SessionMode) => void
}

const FocusModeContext = createContext<FocusModeContextType | undefined>(
	undefined,
)

export function FocusModeProvider({ children }: { children: ReactNode }) {
	const [mode, setMode] = useState<SessionMode>(null)

	return (
		<FocusModeContext.Provider value={{ mode, setMode }}>
			{children}
		</FocusModeContext.Provider>
	)
}

export function useFocusMode() {
	const context = useContext(FocusModeContext)
	if (context === undefined) {
		throw new Error('useFocusMode must be used within a FocusModeProvider')
	}
	return context
}
